<div *ngIf="show"
     class="loader-open">
  <div class="loader-overlay">
    <div class="loader-content">
      <!-- Animated Logo -->
      <img alt="Pouch" class="loader-logo"
           width="70"
           height="70"
           src="images/logo.svg">

      <!-- Three bouncing balls -->
      <div class="loader-balls">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</div>
